import { GendersList } from "libs/shared-models/gtpl/src/lib/genders/enums/genders.enum";
import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity('user_otp')
export class UserOtp {
    @PrimaryGeneratedColumn('increment',{name:'id'}) 
    Id: number;  
    @Column("varchar",{
        nullable:false,
        length:10,
        name:"mobile_no"
    })
    mobileNo:string;
    @Column("varchar",{
        nullable:false,
        length:500,
        name:'first_name'
    })
    firstName:string;
    @Column("varchar",{
        nullable:true,
        length:500,
        name:"membership_img"
      })  
      membershipImg:string;
      @Column("varchar",{
        nullable:true,
        length:500,
        name:"membership_id"
      })  
      membershipId:string;
    @Column("int",{
        nullable: false,
        name:"otp"
    })
    otp:number;
    @Column({
        nullable: false,     
        name:"otp_expire",
        type:'datetime'
    })
    otpExpire:Date;
    @Column({
        nullable:true,
        name: "dob",
        type:'date'
      })
      dob: Date;
      @Column({
        type:'enum',
        nullable: true,
        enum:GendersList,
        default:GendersList.MALE,
        name:"gender"
      })
      gender:GendersList;
      @Column("int",{
        nullable:true,
        name:'wardno_id'
      })
      wardnoId:number;
      @Column("varchar",{
        nullable:true,
        length:500,
        name:'house_number'
      })
      houseNumber:string;
      @Column("int",{
        nullable:true,
        name:'mandal_id'
      })
      mandalId:number;
      @Column("int",{
        nullable: true,
        name:"village_id"
      })
      villageId?:number;
      @Column("int",{
        nullable: true,
        name:"hamlet_id"
      })
      hamletId?:number;
}